import BoxKit from "@/shared/components/kit/box";
import StackKit from "@/shared/components/kit/stack";
import React, { useState } from "react";
import AlignVerticalBottomIcon from "@mui/icons-material/AlignVerticalBottom";

import TypoGraphyKit from "@/shared/components/kit/typoGraphy";
import ImgStaticCard from "@/shared/components/common/imgStaticCard/imgStaticCard";
import { Grid, useMediaQuery } from "@mui/material";
import { BalanceData } from "@/types/api/user/home.type.data";
import { numberSeparator } from "@/hooks/useThousandsSeparator";
import CustomSelectNormal from "@/shared/components/common/select/selectNormal";
import theme from "@/style/theme";
/**
 * HeaderWallet
 *
 * کامپوننت هدر کیف پول کاربر.
 *
 * این کامپوننت اطلاعات کلی موجودی کیف پول را نمایش می‌دهد و شامل:
 * - نمایش موجودی نقدی و اعتباری
 * - انتخاب نوع موجودی با `CustomSelectNormal`
 * - کارت تصویری با استفاده از `ImgStaticCard`
 * - طراحی ریسپانسیو برای نمایش صحیح در موبایل و دسکتاپ
 *
 * ویژگی‌ها:
 * - طراحی ریسپانسیو با `useMediaQuery` و breakpoints تعریف شده در theme
 * - استفاده از StackKit و BoxKit برای چینش عناصر
 * - آیکون و عنوان بخش گزارش ها کیف پول
 * - انتخاب موجودی با `CustomSelectNormal`
 * - نمایش تصویر کارت با `ImgStaticCard`
 *
 * کامپوننت‌های داخلی استفاده شده:
 * - StackKit
 * - BoxKit
 * - TypoGraphyKit
 * - CustomSelectNormal
 * - ImgStaticCard
 * - آیکون AlignVerticalBottomIcon از @mui/icons-material
 *
 * @component
 * @param {Object} props
 * @param {BalanceData | undefined} props.dataBalance - داده‌های موجودی کیف پول کاربر
 *
 * @example
 * ```tsx
 * const dataBalance = {
 *   balance: 1200000,
 *   credit: { balance: 500000 },
 * };
 *
 * <HeaderWallet dataBalance={dataBalance} />
 * ```
 */

const HeaderWallet = ({ dataBalance }: { dataBalance: BalanceData | undefined }) => {
  const [selected, setSelected] = React.useState("all");
  const isSmall = useMediaQuery(theme.breakpoints.down("sm"));

  const dataOptionSelect = [
    {
      label: `موجودی نقدی : ${numberSeparator(`${dataBalance?.balance}`) ?? 0}`,
      value: "all",
    },
    {
      label: `موجودی اعتباری :  ${
        numberSeparator(`${dataBalance?.credit?.balance}`) ?? 0
      }`,
      value: "cash_20card",
    },
  ];

  return (
    <StackKit direction="row" className="w-full px-[20px] justify-between items-center">
      <Grid
        direction={isSmall ? "column" : "row"}
        justifyContent={{ sm: "center", md: "space-between" }}
        gap={2}
        alignItems="center"
        container
        sx={{ width: "100%" }}
      >
        {/* Title and Icon */}
        <BoxKit>
          <StackKit direction="row" sx={{ marginTop: "50px" }} alignItems="center">
            <AlignVerticalBottomIcon sx={{ color: "#fff", ml: 0, fontSize: "32px" }} />
            <TypoGraphyKit sx={{ ml: "0 !important" }} variant="subtitle1">
              گزارش های خرید اعتباری
            </TypoGraphyKit>
          </StackKit>
        </BoxKit>

        {/* Select and Card */}
        <BoxKit>
          <StackKit
            className="w-full"
            direction={{ sm: "row", xs: "column-reverse" }}
            alignItems="center"
            sx={{ marginTop: "50px" }}
          >
            <BoxKit sx={{ minWidth: { sm: "250px", xs: "100%" }, mt: 2 }}>
              <CustomSelectNormal
                label=""
                value={selected}
                onChange={(e) => setSelected(e.target.value)}
                options={dataOptionSelect}
                getOptionLabel={(item) => item.label}
                getOptionValue={(item) => item.value}
                width="100%"
              />
            </BoxKit>

            <BoxKit className="w-[180px] h-[180px]" sx={{ mt: 2 }}>
              <ImgStaticCard
                imgSlider1="card-out-simple-flat2.png"
                imgSlider2="/slide2.jpg"
                img1Height="180px"
              />
            </BoxKit>
          </StackKit>
        </BoxKit>
      </Grid>
    </StackKit>
  );
};

export default HeaderWallet;
